import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {NotificationProvider} from '../../../../models/notificationProvider';
import {User} from '../../../../models/user';
import {CommonService} from '../../../../services/common.service';
import {ToastMessagesService} from '../../../../services/toast-messages.service';

@Component({
    selector: 'app-parent-info-dialog',
    templateUrl: './parent-info-dialog.component.html',
    styleUrls: ['./parent-info-dialog.component.scss']
})
export class ParentInfoDialogComponent implements OnInit {
    parentInfo: any;
    notificationProviders: any;
    parent: any;
    isLoading = false;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private commonService: CommonService,
                public toastMessagesService: ToastMessagesService, public dialogRef: MatDialogRef<ParentInfoDialogComponent>) {
        this.parent = data.parent;
    }

    async ngOnInit() {

        await this.getParentInfo();
    }

    async getParentInfo() {
        this.isLoading = true;
        try {
            const parentRequest = await this.commonService.getList(`people/parentInfo?userId=${this.parent.userId}`);
            this.parentInfo = parentRequest.object[0] as User;
            await this.getNotificationProviders();
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        } finally {
            this.isLoading = false;
        }
    }

    async getNotificationProviders() {
        try {
            const providersRequest = await this.commonService.getList(`common/notification_providers`);
            this.notificationProviders = providersRequest.object as NotificationProvider[];
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }

    close() {
        this.dialogRef.close();
    }

    checkWindowState($event: boolean) {
        if ($event) {
            this.dialogRef.close();
        }
    }
}
